import React, { useEffect, useState } from "react";
import styled, { keyframes, css } from "styled-components";
import { useHistory } from "react-router-dom";
import ChatBot from "./AI-Demos/ChatBot";
import { RiFlowChart, RiRobot2Line } from "react-icons/ri";
import {
  LuCalendarClock,
  LuCalendarDays,
  LuSendHorizontal,
  LuRefreshCw,
} from "react-icons/lu";
import { GrServices } from "react-icons/gr";
import { TbClock24, TbClockCheck } from "react-icons/tb";
import { MdApproval, MdArrowForward, MdLanguage } from "react-icons/md";
import Testimonial from "../components/Sections/Testimonial";
import { animateScroll as scroll } from "react-scroll";
import { BsDatabaseLock } from "react-icons/bs";
import axios from "axios";

const ChatBotPage = () => {
  const history = useHistory();
  const [prompts, setPrompts] = useState([]);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [refreshRotating, setRefreshRotating] = useState(false);
  const [requestToken, setRequestToken] = useState("");

  // Generate a UUID v4
  function generateUUID() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  const handleGoHome = () => {
    history.push("/"); // Redirects to the homepage
  };

  // List of 15 prompts
  const listPrompts = [
    "Write a short poem about technology",
    "Explain quantum computing to a 10-year-old",
    "Give me 3 quick dinner ideas",
    "Tell me a fun fact about space",
    "Help me draft a thank you email",
    "What should I pack for a weekend trip?",
    "Suggest a 15-minute workout routine",
    "Tell me a short joke",
    "How do I improve my public speaking?",
    "Recommend a book for beginners in photography",
    "Write a creative product description for headphones",
    "Give me 3 tips for better sleep",
    "Explain blockchain in one paragraph",
    "Help me brainstorm a team building activity",
    "What are some ways to reduce digital eye strain?",
  ];

  // Function to get 5 random prompts
  const getRandomPrompts = () => {
    return listPrompts.sort(() => Math.random() - Math.random()).slice(0, 5);
  };

  useEffect(() => {
    scroll.scrollToTop();
    setPrompts(getRandomPrompts());
    const requestId = generateUUID();
    setRequestToken(requestId);
  }, []);

  const handleRefresh = () => {
    setRefreshRotating(true);
    setInput("");
    setMessages([]);
  };

  const handleSend = async (input) => {
    if (!input.trim()) return;

    // Add user message to chat
    setMessages([...messages, { from: "user", text: input }]);
    setInput("");
    setLoading(true);

    //
    let message = { message: { text: input, sessionId: requestToken } };

    // Simulate API call with setTimeout
    setTimeout(() => {
      axios
        .post(
          "https://test.ct-n8n.ctserver.space/webhook/854af769-7f92-4f1b-92d4-bda6d1422561",
          message
        )
        .then((res) => {
          console.log("🚀 ~ ChatBotPage.jsx:82 ~ .then ~ res:", res);
          setMessages((prev) => [
            ...prev,
            { from: "bot", text: res.data.output },
          ]);
          setLoading(false);
        })
        .catch((err) => {
          console.log("🚀 ~ ChatBotPage.jsx:88 ~ .then ~ err:", err);
        });
    }, 1500);
  };

  const handleTryPrompt = (prompt) => {
    handleSend(prompt);
  };

  return (
    <>
      <Wrapper className="flexNullCenter flexColumn">
        <HeroContainer>
          <ContentWrapper>
            <TextContent>
              <IconWrapper>
                <Icon>
                  <RiRobot2Line fontSize={44} />
                </Icon>
              </IconWrapper>
              <Title>Smart Conversations Made Simple</Title>
              <Subtitle>
                Instant Answers, Real Solutions, Available 24/7
              </Subtitle>
              <Description>
                Meet your new digital assistant that understands, learns, and
                responds just like a human—only faster and available around the
                clock.
              </Description>
              <DescriptionPoint>
                {prompts.map((item, index) => {
                  return (
                    <PromptWrapper>
                      <PromptDiv
                        className="shadow"
                        duration="500ms"
                        delay={`${index * 200}ms`}
                        key={index}
                      >
                        <Prompt className="whiteColor">{item}</Prompt>
                      </PromptDiv>
                      <TryButton onClick={() => handleTryPrompt(item)}>
                        Try it
                        {/* <MdArrowForward /> */}
                      </TryButton>
                    </PromptWrapper>
                  );
                })}
              </DescriptionPoint>
            </TextContent>

            {/* <ChatBot /> */}
            <>
              <ChatPreview>
                <ChatWindow>
                  <ChatHeader>
                    <BotInfo>
                      <RiRobot2Line fontSize={24} />
                      <BotName>Chatbot</BotName>
                    </BotInfo>
                    <RefreshIcon
                      onClick={handleRefresh}
                      rotating={refreshRotating}
                      onAnimationEnd={() => setRefreshRotating(false)}
                    >
                      <LuRefreshCw fontSize={22} />
                    </RefreshIcon>
                  </ChatHeader>
                  <ChatBody>
                    {messages.length === 0 && (
                      <ChatMessage>
                        ---- Chat application start here. ----
                      </ChatMessage>
                    )}

                    {messages.map((msg, idx) => (
                      <ChatMessage
                        key={idx}
                        style={{
                          textAlign: msg.from === "user" ? "right" : "left",
                        }}
                      >
                        <div
                          style={{
                            backgroundColor:
                              msg.from === "user" ? "#7620ff" : "#f3f4f6",
                            color: msg.from === "user" ? "#fff" : "#374151",
                            padding: "4px 12px",
                            borderRadius: "10px",
                            letterSpacing: "1px",
                            fontSize: "16px",
                            display: "inline-block",
                            margin: "4px 0",
                            maxWidth: "300px",
                            overflow: "hidden",
                          }}
                        >
                          <p
                            style={{
                              overflowWrap: "break-word",
                              whiteSpace: "normal",
                            }}
                          >
                            {msg.text}
                          </p>
                        </div>
                      </ChatMessage>
                    ))}

                    {loading && (
                      <ChatMessage style={{ textAlign: "left" }}>
                        <div
                          style={{
                            backgroundColor: "#f3f4f6",
                            color: "#374151",
                            padding: "4px 20px",
                            borderRadius: "10px",
                            fontSize: "16px",
                            display: "inline-block",
                          }}
                        >
                          <p>Loading...</p>
                        </div>
                      </ChatMessage>
                    )}
                  </ChatBody>

                  <ChatInputContainer>
                    <ChatInput
                      id="text"
                      name="text"
                      type="text"
                      placeholder="Write a text here..."
                      value={input}
                      onChange={(e) => setInput(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") handleSend(input);
                      }}
                    />
                    <SendButton
                      onClick={() => handleSend(input)}
                      disabled={loading}
                    >
                      <LuSendHorizontal fontSize={18} />
                    </SendButton>
                  </ChatInputContainer>
                </ChatWindow>
              </ChatPreview>
            </>
          </ContentWrapper>
        </HeroContainer>
      </Wrapper>

      <DemoSampleWrapper className="lightBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Features</h1>
            <p className="font13">
              Unlock the full potential of AI-driven conversations with features
              designed to enhance user experience, boost efficiency, and deliver
              support that never sleeps.
              <br />
              Each capability is purpose-built to meet your customers’
              expectations while streamlining your operations—smarter
              conversations, better results.
            </p>
          </HeaderInfo>
          <DemoSampleWrapperDiv>
            <FeatureWrapper className="whiteBg radius8 shadow">
              <DemoFeatureDiv>
                <DemoFeatureIcon>
                  <LuCalendarDays fontSize={26} />
                </DemoFeatureIcon>
                <DemoFeatureTitle className="font20 extraBold">
                  24/7 Availability
                </DemoFeatureTitle>
              </DemoFeatureDiv>
              <DemoFeatureDesc className="font13">
                Never miss a customer inquiry again. Our chatbot works around
                the clock, handling questions and providing assistance even when
                your team is offline.
              </DemoFeatureDesc>
            </FeatureWrapper>
            <FeatureWrapper className="whiteBg radius8 shadow">
              <DemoFeatureDiv>
                <DemoFeatureIcon>
                  <LuCalendarClock fontSize={26} />
                </DemoFeatureIcon>
                <DemoFeatureTitle className="font20 extraBold">
                  Multi-Channel Integration
                </DemoFeatureTitle>
              </DemoFeatureDiv>
              <DemoFeatureDesc className="font13">
                Connect with users wherever they are—website, mobile app, social
                media, or messaging platforms—with consistent service across all
                touchpoints.
              </DemoFeatureDesc>
            </FeatureWrapper>
            <FeatureWrapper className="whiteBg radius8 shadow">
              <DemoFeatureDiv>
                <DemoFeatureIcon>
                  <MdLanguage fontSize={26} />
                </DemoFeatureIcon>
                <DemoFeatureTitle className="font20 extraBold">
                  Natural Language Understanding
                </DemoFeatureTitle>
              </DemoFeatureDiv>
              <DemoFeatureDesc className="font13">
                Your users don’t need to learn commands. The chatbot understands
                everyday language, slang, and even emojis—delivering helpful,
                context-aware responses that feel truly conversational.
              </DemoFeatureDesc>
            </FeatureWrapper>
            <FeatureWrapper className="whiteBg radius8 shadow">
              <DemoFeatureDiv>
                <DemoFeatureIcon>
                  <TbClockCheck fontSize={26} />
                </DemoFeatureIcon>
                <DemoFeatureTitle className="font20 extraBold">
                  Intent Detection & Smart Routing
                </DemoFeatureTitle>
              </DemoFeatureDiv>
              <DemoFeatureDesc className="font13">
                Beyond answering FAQs, the chatbot detects intent and can route
                complex queries to the right department, or escalate to a human
                agent when needed.
              </DemoFeatureDesc>
            </FeatureWrapper>
            <FeatureWrapper className="whiteBg radius8 shadow">
              <DemoFeatureDiv>
                <DemoFeatureIcon>
                  <RiFlowChart fontSize={26} />
                </DemoFeatureIcon>
                <DemoFeatureTitle className="font20 extraBold">
                  Customizable Workflows
                </DemoFeatureTitle>
              </DemoFeatureDiv>
              <DemoFeatureDesc className="font13">
                Tailor the bot to your unique business needs—lead generation,
                appointment scheduling, feedback collection, or onboarding—no
                coding required.
              </DemoFeatureDesc>
            </FeatureWrapper>
            <FeatureWrapper className="whiteBg radius8 shadow">
              <DemoFeatureDiv>
                <DemoFeatureIcon>
                  <BsDatabaseLock fontSize={26} />
                </DemoFeatureIcon>
                <DemoFeatureTitle className="font20 extraBold">
                  Data Privacy & Security
                </DemoFeatureTitle>
              </DemoFeatureDiv>
              <DemoFeatureDesc className="font13">
                Built with enterprise-grade encryption and compliance standards
                to keep your customer data safe and secure.
              </DemoFeatureDesc>
            </FeatureWrapper>
          </DemoSampleWrapperDiv>
        </div>
      </DemoSampleWrapper>

      {/* Testimonial */}
      <Testimonial />
    </>
  );
};

const Wrapper = styled.section`
  width: 100%;
  max-width: 1220px;
  margin: 0 auto;
  padding: 110px 30px 0px 30px;
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

const HeroContainer = styled.section`
  background-color: #f9fafb;
  display: flex;
  align-items: center;
  padding: 32px;
`;

const ContentWrapper = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 32px;

  @media (max-width: 1024px) {
    flex-direction: column;
    text-align: center;
  }
`;

const TextContent = styled.div`
  flex: 1;
  min-width: 300px;
`;

const Title = styled.h1`
  font-size: 36px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 16px;
`;

const Subtitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: #4b5563;
  margin-bottom: 16px;
`;

const Description = styled.p`
  font-size: 18px;
  color: #6b7280;
  margin-bottom: 32px;
  line-height: 2;
`;

const DescriptionPoint = styled.p`
  font-size: 16px;
  color: #6b7280;
  margin-bottom: 32px;
  line-height: 1.6;
`;

const IconWrapper = styled.div`
  position: relative;
  margin-bottom: 32px;
  display: flex;
  @media (max-width: 600px) {
    justify-content: center;
  }
  @media (max-width: 1024px) {
    justify-content: center;
  }
`;

const Icon = styled.div`
  width: 70px;
  height: 70px;
  background-color: #f3f4f6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
`;

const IconImage = styled.img`
  width: 40px;
  height: 40px;
`;

const DemoSampleWrapper = styled.div`
  margin-top: 50px;
  padding: 50px 0px;
`;

const HeaderInfo = styled.div`
  margin-bottom: 30px;
  @media (max-width: 860px) {
    text-align: center;
  }
`;

const DemoSampleWrapperDiv = styled.div`
  width: 100%;
  max-width: 1220px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  @media (max-width: 600px) {
    justify-content: center;
  }
  @media (max-width: 1024px) {
    justify-content: space-around;
  }
`;

const FeatureWrapper = styled.div`
  width: 350px;
  height: 220px;
  text-align: left;
  padding: 20px 30px;
  margin: 30px 0px;
  transition: transform 0.3s, box-shadow 0.3s;

  &:hover {
    transform: scale(1.05) translateY(-5px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
  }
`;

// Fade-in animation
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const PromptWrapper = styled.div`
  display: flex;
  align-items: baseline;
`;

const PromptDiv = styled.div`
  background: #7620ff;
  padding: 10px 15px;
  border-radius: 12px;
  width: fit-content;
  max-width: 600px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 4px 4px -1px rgba(0, 0, 0, 0.06);
  margin-bottom: 15px;

  // Add animation
  animation: ${fadeIn} ease-in-out forwards;

  // Delay based on index (if dynamic)
  animation-duration: ${(props) => props.duration || "500ms"};
  animation-delay: ${(props) => props.delay || "0ms"};
`;

const Prompt = styled.p`
  font-size: 16px;
  font-weight: bold;
`;

const TryButton = styled.p`
  color: #7620ff;
  font-size: 16px;
  cursor: pointer;
  text-decoration: underline;
  margin-left: 12px;
  white-space: nowrap;
`;

const DemoFeatureDiv = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const DemoFeatureIcon = styled.div`
  width: 30%;
  width: 60px;
  height: 60px;
  background-color: #f3f4f6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
`;

const DemoFeatureTitle = styled.h3`
  width: 70%;
  padding: 10px 15px;
`;

const DemoFeatureDesc = styled.p`
  padding: 10px 0px;
`;

const ChatPreview = styled.div`
  flex: 1;
  min-width: 300px;
  max-width: 450px;

  @media (max-width: 1024px) {
    min-width: 100%;
  }
`;

const ChatWindow = styled.div`
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  overflow: hidden;
`;

const ChatHeader = styled.div`
  background-color: #7620ff;
  color: white;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const BotInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const BotName = styled.span`
  font-size: 16px;
  font-weight: 600;
`;

// Keyframes for 360deg rotation
const rotate360 = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

const RefreshIcon = styled.div`
  width: 24px;
  height: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ rotating }) =>
    rotating &&
    css`
      animation: ${rotate360} 1s linear;
    `}
`;

const ChatBody = styled.div`
  padding: 24px;
  height: 450px;
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

const ChatMessage = styled.div`
  text-align: center;
  color: #6b7280;
  margin-bottom: 10px;
`;

const ChatInputContainer = styled.div`
  margin: 0px 24px 24px 24px;
  display: flex;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  overflow: hidden;
  margin-top: auto;
`;

const ChatInput = styled.input`
  flex: 1;
  padding: 12px 16px;
  border: none;
  outline: none;
  font-size: 14px;
  color: #374151;

  &::placeholder {
    color: #9ca3af;
  }
`;

const SendButton = styled.button`
  background-color: #7620ff;
  color: white;
  border: none;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export default ChatBotPage;
